import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Clock, Calendar, Shield } from "lucide-react";

const cards = [
  {
    icon: Clock,
    title: "Instant Detection",
    text: "ClearMakes spots dates and times inside any email or message instantly.",
    className: "text-amber-400",
  },
  {
    icon: Calendar,
    title: "One-Click Booking",
    text: "Click once to add the event to your Google Calendar and send an invite to the sender.",
    className: "text-primary",
  },
  {
    icon: Shield,
    title: "Conflict Guard",
    text: "We check your availability before drafting a reply, so you never double-book yourself.",
    className: "text-emerald-400",
  },
];

export const CalendarIntelligenceSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 noise-texture" />
      <div className="container relative z-10" ref={ref}>
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="heading-lg mb-4">Calendar Intelligence</h2>
          <p className="body-lg max-w-xl mx-auto text-muted-foreground">
            The time saver. Text-to-event in one click.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {cards.map((card, i) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={card.title}
                className="glass-panel p-8 rounded-2xl border border-white/10"
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: i * 0.1 }}
              >
                <div className={`w-14 h-14 rounded-xl bg-white/5 flex items-center justify-center mb-5 ${card.className}`}>
                  <Icon className="w-7 h-7" />
                </div>
                <h3 className="text-lg font-semibold mb-3">{card.title}</h3>
                <p className="text-sm text-muted-foreground">{card.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
